import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuthState } from "../state";

const UnprotectedRoute = ({ children, path, ...routeProps }: RouteProps) => {
  const { authenticated } = useAuthState();
  if (authenticated) {
    return <Redirect to="/" />;
  }

  return (
    <Route path={path} {...routeProps}>
      {children}
    </Route>
  );
};

export default UnprotectedRoute;
